module.exports = "/_next/static/videos/preview-52f010109b8fc8df1d27329943396dd4.mp4";